import { ProtectedJsonAPI } from './ProtectedJsonAPI'

export const Fees = ProtectedJsonAPI.extend(
  '/fees',
  {
    update:    endpoint => endpoint.method('put').path(({id}) => id)
  }
)
